var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{staticClass:"content"},[(_vm.isOffline)?_c('div',{staticClass:"alert alert-danger"},[_c('strong',[_vm._v("Você está offline!")]),_vm._v(" Por favor, certifique-se que seu dispositivo esteja conectado à internet para utilizar o sistema")]):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }